import React from 'react';

const PageLoadingSkeleton: React.FC = () => (
  <div className="flex items-center justify-center min-h-screen bg-gray-950">
    <div className="flex flex-col items-center gap-4">
      <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
      <p className="text-sm text-gray-400 animate-pulse">Loading…</p>
    </div>
  </div>
);

export default PageLoadingSkeleton;
